import { __decorate } from "tslib";
import { CBcHospitalHisConfigDatabase, CBcHospitalHisConfigWebService } from '@/classes/BcClasses';
import BcDialog, { CBcDialog, CBcDialogForm } from '@/components/Dialog.vue';
import { Component, Vue } from 'vue-property-decorator';
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
class CHisForm extends CBcDialogForm {
    constructor(type, op) {
        super();
        const that = this;
        that.type = type;
        if (op && /object/i.test(typeof op)) {
            Object.keys(op).forEach((k) => {
                if (k !== 'info')
                    that[k] = op[k];
            });
        }
        that.info = /web/i.test(that.type) ? new CBcHospitalHisConfigWebService(op && op.info) : new CBcHospitalHisConfigDatabase(op && op.info);
    }
}
let BcHisInfo = class BcHisInfo extends Vue {
    constructor() {
        super();
        this.snackbar = new CBcSnackbar();
        this.dialogHis = new CBcDialog(new CHisForm());
        this.hospitals = [];
        const that = this;
        // that.dlgMobileNewRecord = new CBcDialog(new CBcDialogForm())
    }
    async createDialog(type, data) {
        const that = this;
        data = data || {};
        that.clickData = data;
        that.dialogHis.type = type;
        if (that.dialogHis.isEditType || that.dialogHis.isDeleteType) {
            that.dialogHis.form = new CHisForm(data.type, Object.assign(data, data.config));
            // that.dialogHis.hospitalId = data.item.hospitalId
        }
        else if (that.dialogHis.isCreateType) {
            that.dialogHis.form = new CHisForm('', Object.assign({}, {}));
            await that.getHospitals();
            if (data.addHospId) {
                that.dialogHis.form.hospitalId = data.addHospId;
            }
        }
        that.dialogHis.width = /^xs$/i.test(that.$vuetify.breakpoint.name) ? '95%' : '60%';
        that.dialogHis.title = (that.dialogHis.isCreateType ? '新增' : that.dialogHis.isEditType ? '编辑' : '删除') + '医院信息系统对接信息';
        that.dialogHis.visible = true;
        that.dialogHis.displayText = false;
    }
    async dialogInfoSave() {
        const that = this;
        const handleName = (that.dialogHis.isCreateType ? '新增' : that.dialogHis.isEditType ? '编辑' : '删除') + '医院信息系统对接信息';
        that.dialogHis.loading = true;
        that.dialogHis.autoClose = false;
        if (!that.dialogHis.form.hospitalId) {
            that.snackbar.error('医院不能为空，请先选择医院！');
            that.dialogHis.loading = false;
            // that.dialogHis.visible = true;
            return false;
        }
        try {
            that.dialogHis.autoClose = true;
            if (that.dialogHis.isEditType)
                await that.axios.put(`/api/hospital/his/${that.dialogHis.form.id}`, that.dialogHis.form);
            else if (that.dialogHis.isCreateType)
                await that.axios.post('/api/hospital/his', that.dialogHis.form);
            else
                await that.axios.delete(`/api/hospital/his/${that.dialogHis.form.id}`);
            that.dialogHis.loading = false;
            that.snackbar.success(`${handleName}成功！`);
            // that.getHisInfo(that.winItem.selectHospital && that.winItem.selectHospital.id || 0)
            that.$emit('saveCheck', false, `${handleName}成功！`);
        }
        catch (e) {
            that.dialogHis.loading = false;
            that.dialogHis.visible = true;
            // TODO: dialog处理失败后不应close对话框
            that.snackbar.error(`${handleName}过程出错:` + (e && (e.info || e.result || e.error)));
        }
    }
    async getHospitals() {
        const that = this;
        try {
            const res = (await that.axios.get('/api/hospital?isSummaryDetail=false&hisInfoStatus=2'));
            that.hospitals = res && res.data && res.data.result || [];
        }
        catch (e) {
            console.log('error of get hosp list in createRecord:', e);
            that.snackbar.error('医院信息获取失败,' + (e && (e.errorInfo || e.result || e.toString())));
        }
    }
    hospitalFilter(item, queryText, itemText) {
        return new RegExp(queryText.toUpperCase(), 'i').test(item['name'].toUpperCase());
    }
    dialogInfoClose() {
        const that = this;
        that.dialogHis.visible = false;
    }
};
BcHisInfo = __decorate([
    Component({
        name: 'BcHisInfo',
        components: {
            BcSnackbar,
            BcDialog
        },
    })
], BcHisInfo);
export default BcHisInfo;
